import React from 'react'
import { education, experience } from '../../utils/acadProfData'

const Experience = () => {
  return (
    <div className='p-4 mt-5'>
        <div className='ExperienceHeader'>
            <h1 className='fw-bolder'>My <span className='fw-medium fst-italic text-warning'>Academic and</span></h1>
            <h1 className='fw-bolder'><span className='fw-medium fst-italic text-warning'>Professional</span> Journey</h1>
        </div>
        <div className='ExperienceCardWrapper p-4 mt-4 row justify-content-center'>
            <div className="card bg-body-tertiary mb-3 col-md-4 mx-5 my-2">
                <div className="card-header bg-body-tertiary text-start">
                    <div className='cardHeader d-flex align-items-center'>
                        <img src='educationIcon.png' alt='...' style={{ width: '50px' }}/>
                        <h1 className='fs-3 fw-bolder ms-2'>Education</h1>
                    </div>
                </div>
                <div className="card-body">
                    {education.map(ed =>{
                        return(
                            <div className='border-start border-5 text-start mb-4 p-2'>
                                <h3 className="card-title ms-2 fs-4 fw-semibold">{ed.institute}</h3>
                                <h5 className='card-text ms-2 fs-5'>{ed.title}</h5>
                                <p className='card-text ms-2 fw-normal text-body-secondary'>{ed.startYear} - {ed.endYEear}  <span className='ms-3'>Grade : {ed.grade}</span></p>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className="card bg-body-tertiary mb-3 col-md-4 mx-5 my-2">
                <div className="card-header bg-body-tertiary text-start">
                    <div className='cardHeader'>
                    <div className='cardHeader d-flex align-items-center'>
                        <img src='experienceIcon.png' alt='...' style={{ width: '50px' }}/>
                        <h1 className='fs-3 fw-bolder ms-3'>Work Experience</h1>
                    </div>
                    </div>
                </div>
                <div className="card-body">
                    {experience.map(exp =>{
                        return(
                            <div className='border-start border-5 text-start mb-4 p-2'>
                                <h3 className="card-title ms-2 fs-4 fw-semibold">{exp.institute}</h3>
                                <h5 className='card-text ms-2 fs-5'>{exp.title}</h5>
                                <p className='card-text ms-2 fw-normal text-body-secondary'>{exp.startYear} - {exp.endYEear}</p>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    </div>
  )
}

export default Experience